import { getAddress } from 'viem';

// Raw data types (as stored in JSON files)
type RawParticipation = { participant: string; amount: string };

export type RawInputData = {
  contract_data: {
    token: string;
    chain_id: number;
    claimer_contract: string;
  };
  week_to_campaign_mapping: {
    week: number;
    campaign: string;
    code: CampaignCode;
  };
  input: RawParticipation[];
};

// Processed data types (with normalized addresses)
export type Participation = { participant: `0x${string}`; amount: string };
export const ALL_CAMPAIGN_CODES = [
  'road-to-velora',
  'bankless',
  //  'cookie3'
] as const;
export type CampaignCode = (typeof ALL_CAMPAIGN_CODES)[number];

export type InputData = {
  contract_data: {
    token: `0x${string}`;
    chain_id: number;
    claimer_contract: string;
  };
  week_to_campaign_mapping: {
    week: number;
    campaign: string;
    code: CampaignCode;
  };
  input: Participation[];
};

export type ParticipationWithProofs = Participation & {
  merkleProofs: string[];
};
export type CampaignResult = {
  root: {
    merkleRoot: string;
    totalAmount: string;
    week_to_campaign_mapping: InputData['week_to_campaign_mapping'];
  };
  contract_data: InputData['contract_data'];
  participants_with_proofs: ParticipationWithProofs[];
};

// Utility functions for address normalization
export const normalizeAddress = (address: string): `0x${string}` => {
  return getAddress(address) as `0x${string}`;
};

// Convert raw JSON data to processed data with normalized addresses
export const processRawInputData = (rawData: RawInputData): InputData => {
  return {
    ...rawData,
    contract_data: {
      ...rawData.contract_data,
      token: normalizeAddress(rawData.contract_data.token),
    },
    input: rawData.input.map((entry) => ({
      participant: normalizeAddress(entry.participant),
      amount: entry.amount,
    })),
  };
};

export type ClaimedStatusByCampaign = Record<CampaignCode, boolean>;
export function isCampaignCode(code: string): code is CampaignCode {
  return ALL_CAMPAIGN_CODES.includes(code as CampaignCode);
}
